import Vue from 'vue';
import dialogNoticeVue from './dialogNotice.vue';
import dialogNoticeIpVue from './dialogNoticeIp.vue';
import dialogNoticeVueStyle2 from './dialogNoticeStyle2.vue';
const DialogNotice = (options) => {
	var style_xml = "";
	if(options.xml){
		style_xml = dialogNoticeIpVue;
	}else if(options.style == 1){
		style_xml = dialogNoticeVue;
	}else{
		style_xml = dialogNoticeVueStyle2;
	}
	const DialogNoticeConstructor = Vue.extend(style_xml);
	let instance = new DialogNoticeConstructor({
		data: options
	});
	instance._vm = instance.$mount();
	instance._el = instance.$el;
	instance._instance = instance;
	document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
	return instance;
};

export default DialogNotice;
